/* eslint-disable react/prop-types */
import ComposedViewDetail from "./composed-view-detail";
import Flex from "@/components-library/layout/flex";
import classes from "./announcement-detail.module.scss";
import QuoteForm from "./quote-form";
//import ComposedViewFive from "@/composed-views/composed-view-five";
import CumulativeAnnoucements from "./cumulative-announcements";
import CumulativeServices from "./cumulative-services";
import Modal from "@/components-library/widgets/modal";
import AnnouncementModal from "./announcement-modal";
import Spinner from "@/components-library/widgets/spinner";
import { Status } from "@/views/admin-dashboard/admin.slice";
import Button from "@/components-library/widgets/button";

function AnnouncementDetail({
  announcement,
  correlatedAnnouncements,
  correlatedServices,
  modalAnnouncement,
  offer,
  announcements,
  onClickConfirm,
  onClickDelete,
  status,
  admin,
}) {
  if (announcement) {
    return (
      <Flex
        align="flex-start"
        direction="column"
        justify="flex-start"
        className={classes.container}
      >
        <Modal isOpen={modalAnnouncement !== undefined}>
          <AnnouncementModal announcement={modalAnnouncement} />
        </Modal>

        <Modal
          isOpen={
            status === Status.CREATING ||
            status === Status.DELETING ||
            status === Status.UPDATING
          }
        >
          <Spinner />
        </Modal>

        <ComposedViewDetail announcement={announcement} />

        <CumulativeAnnoucements
          announcement={announcement}
          announcements={correlatedAnnouncements}
          admin={admin}
          offer={offer}
        />

        <CumulativeServices
          services={correlatedServices}
          fromAdmin={false}
          offer={offer}
          allAnnouncements={announcements}
          announcement={announcement}
        />

        {!admin && (
          <QuoteForm
            currentAnnouncement={announcement}
            offer={offer}
            correlatedAnnouncements={correlatedAnnouncements}
            services={correlatedServices}
          />
        )}
        {admin && (
          <Flex
            align="flex-start"
            direction="row"
            justify="center"
            className={classes.actions}
          >
            <Button
              onClick={onClickConfirm}
              size="sm"
              color="primary"
              className={classes.action}
            >
              CONFERMA
            </Button>

            <Button
              onClick={onClickDelete}
              size="sm"
              color="primary"
              isEnabled={announcement?.id !== undefined}
              className={classes.action}
            >
              ELIMINA
            </Button>
          </Flex>
        )}
      </Flex>
    );
  } else return <span>Error</span>;
}

export default AnnouncementDetail;
